import {Product} from '../../@types/wishlist.js';

export class ProductApiInstance {
  async getProduct(endpoint: string, syan: string, articleId?: string, colorId?: string): Promise<Product> {
    const articleIdParam = this.isSet(articleId) ? `?articleId=${articleId}` : '';
    let colorIdParam = '';
    if (this.isSet(colorId) && this.isSet(articleId)) {
      colorIdParam += `&colorId=${colorId}`;
    } else if (this.isSet(colorId)) {
      colorIdParam += `?colorId=${colorId}`;
    }
    const url = `${endpoint}${syan}${articleIdParam}${colorIdParam}`;

    const fetchOptions: RequestInit = {
      method: 'GET',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      fetchOptions.signal = AbortSignal.timeout(5000);
    }

    const response = await fetch(url, fetchOptions);

    if (response.status >= 400) {
      throw new Error(`Wishlist API call failed: ${await response.text()}`);
    }

    return response.json();
  }

  private isSet(param?: string): boolean {
    return param !== undefined && param !== '' && param !== null  && param !== 'null';
  }
}

export const productApi = new ProductApiInstance();
